export const BearerTokenName = "SegovBearerToken";

export function getBearerToken(): string | null {
  return sessionStorage.getItem(BearerTokenName);
}

export function setBearerToken(token: string) {
  sessionStorage.setItem(BearerTokenName, token);
}

export function removeBearerToken() {
  sessionStorage.removeItem(BearerTokenName);
}
